var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('div',[_vm._v(" test01文档流 ")]),_c('div',[_c('lotteryRounds',{staticClass:"lotteryRounds",attrs:{"records":_vm.lotteryRoundsRecord,"singlePlayTime":_vm.speed},on:{"locationChange":_vm.resLocationChange}})],1),_c('div',[_vm._v(" test01文档流 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }